<template>
	<div></div>
</template>

<script>
	import "@/assets/styles/mainindex/iconfont.css";
		import { getSsoDesInfo, } from "@/api/zlts/jlfw/jljgxx";
		import {
			getlogin,
			checkUuidValidDate
		} from "@/api/index";
		export default {
			//首页
			name: 'IndexJump',
			data() {
				return {
					time: undefined,
					islogin: false,
					selectplaceholder: '请先选择要查询的业务',
					uuid: undefined,
					loginUser: {},
					toUrl:undefined,
					ssoOtherOsInfo:{},
					mloading:undefined,
				}
			},

			mounted() {
				let $this = this;
				// this.createloading();
				if(this.$route.query.error=='error'){
					// this.$message({ showClose: true, message: this.$route.query.msg, type: "error" });
					localStorage.clear();
					sessionStorage.clear();
					this.$alert(this.$route.query.msg, '提示', {
						confirmButtonText: '确定',
						callback: action => {
							localStorage.clear();
							sessionStorage.clear();
							window.location.href = this.Config.sdtyrzfwLoginUrl;
						}
					});
				}
				// console.log("进入jump页面",this.$route.query);
				//登录判断
				//1、判断当前请求参数uuid的长度，如果长度为33,代表从统一认证平台跳转，通过uuid 获取用户登录状态
				//2、判断localStorage 是缓存uuid，如果如直接获取缓存中的用户信息，没有缓存则显示登录按钮
				this.$nextTick(function() {
					let param = this.$route.query;
					// console.log("param==>",param);
					if (param.uuid != undefined && param.uuid != '') {
						this.createloading();
						//验证uuid是否可以解密，验证时间戳是否已经过期
						checkUuidValidDate(param.uuid).then(response => {
							if (response.msg == '901') {
								localStorage.clear();
								this.closeLoading();
								this.$confirm(
									'登录请求已过期，您可以继续留在该页面，或者重新登录',
									'系统提示', {
										confirmButtonText: '重新登录',
										cancelButtonText: '取消',
										type: 'warning'
									}
								).then(() => {
									this.closeLoading();
									localStorage.clear();
									window.location.href = this.Config.sdtyrzfwLoginUrl;
								})
							} else if (response.msg == '906') {
								this.closeLoading();
								localStorage.clear();
								this.msgError("非法请求");
								window.location.href = this.Config.loginJumpUrl
							} else {
								this.uuid = response.msg;
							    console.log("准备登录");
								this.accessSdtyrzfw(this.uuid);
							}
						});
					} else {
						// loading.close();
						// console.log("没参数，直接跳转首页");
						this.toOpenPage('/main/index');
					}
				})
			},
			methods: {
				createloading(){
					this.mloading=this.$loading({lock:true,color:'rgba(4,120,211)',text:"登录中，请稍后...",background:'rgba(0, 0, 0, 0.63)'});
				},
				closeLoading(){
					this.mloading.close();
				},
				accessSdtyrzfw(uuid) {
					getlogin(uuid).then(response => {
						// console.log(">>>>>>>",response);
						
						if (response.msg == '操作成功') {
							this.closeLoading();
              // debugger
              let tmp = response.data.user;
              if((tmp.ywFwjgRecid==null || tmp.ywFwjgRecid=='' || tmp.ywFwjgRecid==undefined)
              && tmp.isWhEnt=='N'){
                swal({
                  title: "温馨提示",
                  text: "您不是威海市企业，不能登录本平台及使用本平台申请申报等业务！",
                  icon: "warning",
                  buttons: [false,"继续浏览本平台"],
                  // dangerMode: true,
                  closeOnClickOutside:false,
                }).then((toLink) => {
                  if (toLink) {
                    this.toOpenPage('/main/index');
                  }
                });

                return;
              }
							localStorage.setItem("sdtyfwpt_uuid", uuid);
							localStorage.setItem("sdtyfwpt_loginuser", JSON.stringify(response.data.user));
							/* let ssessionLoginUser = {
								user:response.data.user != null ? response.data.user : {},
								ywFwjg:response.data.ywFwjg != null ? response.data.ywFwjg :{},
								islogin:true,
								browser:response.data.browser != null ? response.data.browser : undefined,
								enabled:response.data.enabled != null ? response.data.enabled :undefined,
								expireTime:response.data.expireTime != null ? response.data.expireTime : 0,
								ipaddr:response.data.ipaddr != null ? response.data.ipaddr : undefined,
								loginLocation:response.data.loginLocation != null ? response.data.loginLocation : undefined,
								loginTime:response.data.loginTime != null ? response.data.loginTime : 0,
								os:response.data.os != null ? response.data.os : undefined,
								permissions:response.data.permissions != null ? response.data.permissions : undefined,
								token:response.data.token != null ? response.data.token : undefined,
							} */ 	
							let ssessionLoginUser = response.data;
							ssessionLoginUser.islogin = true;
							localStorage.setItem("ssessionLoginUser",JSON.stringify(ssessionLoginUser));
							// console.log("indexJump ssessionLoginUser==",JSON.parse(localStorage.getItem('ssessionLoginUser')));
							this.toOpenPage('/main/index');
						} else {
							this.closeLoading();
							localStorage.clear();
						}
					});
				},
				login() {
					localStorage.clear();
					window.location.href = this.Config.sdtyrzfwLoginUrl;
				},
				toOpenPage(topath) {
					this.$router.push({
						path: topath
					})
					this.$store.commit('SET_MAININDEX', topath);
				},
				
			}
		}
</script>

<style>
</style>
